import React from "react";

const SsoModal = ({
  show,
  onClose,
  providers,
  loading,
  onProviderSelect,
}) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "32px",
          maxWidth: "500px",
          width: "90%",
          maxHeight: "80vh",
          overflow: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "24px",
          }}
        >
          <h2 style={{ margin: 0 }}>Select Identity Provider</h2>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            Loading providers...
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            {providers.map((provider) => (
              <button
                key={provider.id}
                onClick={() => onProviderSelect(provider)}
                style={{
                  padding: "16px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  background: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  transition: "all 0.2s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = "#7f56d9";
                  e.currentTarget.style.background = "#f9fafb";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = "#e5e7eb";
                  e.currentTarget.style.background = "white";
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    background: "#f3f4f6",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2L2 7L12 12L22 7L12 2Z"
                      stroke="#7f56d9"
                      strokeWidth="2"
                    />
                    <path
                      d="M2 17L12 22L22 17"
                      stroke="#7f56d9"
                      strokeWidth="2"
                    />
                    <path
                      d="M2 12L12 17L22 12"
                      stroke="#7f56d9"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
                <div style={{ flex: 1, textAlign: "left" }}>
                  <h3 style={{ margin: "0 0 4px 0", fontSize: "16px" }}>
                    {provider.displayName}
                  </h3>
                  <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
                    {provider.type}
                  </p>
                </div>
                <div style={{ fontSize: "20px", color: "#9ca3af" }}>→</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SsoModal;


